var _style, _rect, _g, _g2, _text;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgLogo(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    x: "0px",
    y: "0px",
    viewBox: "0 0 571.71 185.27",
    style: {
      enableBackground: "new 0 0 571.71 185.27"
    },
    xmlSpace: "preserve",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _style || (_style = /*#__PURE__*/React.createElement("style", {
    type: "text/css"
  }, "\n\t.st0{fill:url(#SVGID_1_);}\n\t.st1{fill:url(#SVGID_00000168815775209933697930000008806523898928370073_);}\n\t.st2{fill:url(#SVGID_00000093153033461452137480000007615934567330502049_);}\n\t.st3{fill:url(#SVGID_00000121272340563081241420000005758684696422992568_);}\n\t.st4{fill:url(#SVGID_00000085951571422257180710000014742054978481859002_);}\n\t.st5{fill:url(#SVGID_00000065062013506422433880000016984519926729601157_);}\n\t.st6{fill:url(#SVGID_00000083798917096155497760000001292156130525149631_);}\n\t.st7{fill:url(#SVGID_00000134234256623537492010000010084001995542238363_);}\n\t.st8{fill:url(#SVGID_00000131327345845763360520000008582056729530123185_);}\n\t.st9{fill:url(#SVGID_00000179642761849329760500000004676916689136754064_);}\n\t.st10{fill:url(#SVGID_00000155131257603116565560000004743606298405263234_);}\n\t.st11{opacity:0.4;fill:url(#SVGID_00000155116154454056170260000003605122492531704223_);}\n\t.st12{fill:url(#SVGID_00000157287996845183211730000012565705062014872203_);}\n\t.st13{opacity:0.64;fill:url(#SVGID_00000026845184988627277440000011950202037129184936_);}\n\t.st14{opacity:0.4;fill:url(#SVGID_00000150073620171607769990000011322254788362995373_);}\n\t.st15{fill:url(#SVGID_00000120544667234668605750000016266469709892797081_);}\n\t.st16{fill:url(#SVGID_00000005225563763834859620000001347498016423880338_);}\n\t.st17{fill:url(#SVGID_00000120527334431572860130000015293910158927717253_);}\n\t.st18{fill:url(#SVGID_00000150809326775786022220000010384381515050416522_);}\n\t.st19{fill:url(#SVGID_00000147189978057485084600000007987309984795409853_);}\n\t.st20{fill:url(#SVGID_00000037650147930909868580000008713592885717353132_);}\n\t.st21{fill:url(#SVGID_00000047045901969924765030000003617782288073881764_);}\n\t.st22{fill:url(#SVGID_00000092417199016467218540000009044740383316463802_);}\n\t.st23{opacity:0.4;fill:url(#SVGID_00000155136805007167923470000006420366229110266265_);}\n\t.st24{fill:url(#SVGID_00000083806739339947405320000011708211475268787847_);}\n\t.st25{opacity:0.64;fill:url(#SVGID_00000168811043067737005830000009342553642275264689_);}\n\t.st26{opacity:0.4;fill:url(#SVGID_00000052065792805587213540000001660128554400992906_);}\n\t.st27{fill:#E0A82E;}\n\t.st28{fill:url(#SVGID_00000163782813157107518580000007960031004266559932_);}\n\t.st29{fill:url(#SVGID_00000129204528277095871660000008428846594847884458_);}\n\t.st30{fill:url(#SVGID_00000062893511070171152300000009894858672023004856_);}\n\t.st31{fill:url(#SVGID_00000170996824924751480470000004406639697354007205_);}\n\t.st32{fill:url(#SVGID_00000038388828472057737220000001785711720073450134_);}\n\t.st33{fill:url(#SVGID_00000065792754627312155100000013881507509797944737_);}\n\t.st34{fill:url(#SVGID_00000047055528739235249540000003276004603089815441_);}\n\t.st35{fill:url(#SVGID_00000147937846378900238530000001542453095925278370_);}\n\t.st36{fill:url(#SVGID_00000011752802512222245660000017846161595651871382_);}\n\t.st37{fill:url(#SVGID_00000140009898236012309730000000021456714208115366_);}\n\t.st38{opacity:0.4;fill:url(#SVGID_00000005978646885692129590000012943651658966542527_);}\n\t.st39{fill:url(#SVGID_00000053520470723526004240000009539237459406810006_);}\n\t.st40{opacity:0.64;fill:url(#SVGID_00000101811711597900671760000012306807522359380908_);}\n\t.st41{opacity:0.4;fill:url(#SVGID_00000054227696943214551590000001476788359600088225_);}\n\t.st42{fill:url(#SVGID_00000060746352565655708900000009825761622525782420_);}\n\t.st43{fill:url(#SVGID_00000124866068527114503480000015846409028679405745_);}\n\t.st44{font-family:'Montserrat-Medium';}\n\t.st45{font-size:22.1531px;}\n")), /*#__PURE__*/React.createElement("g", {
    id: "BACKGROUND"
  }, /*#__PURE__*/React.createElement("radialGradient", {
    id: "SVGID_1_",
    cx: 78.3534,
    cy: -567.2562,
    r: 250,
    gradientTransform: "matrix(1.9845 0 0 1 168.9945 0)",
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#130066"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#0B003B"
    }
  })), _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    x: -171.65,
    y: -817.26,
    className: "st0",
    width: 992.27,
    height: 500
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "SVGID_00000086678489580080972050000018311272346964833955_",
    cx: 906.9501,
    cy: -523.6598,
    r: 125.9732,
    gradientTransform: "matrix(1.9845 0 0 1.9845 168.9942 558.4916)",
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#130066"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#0B003B"
    }
  })), /*#__PURE__*/React.createElement("rect", {
    x: 1718.88,
    y: -730.74,
    style: {
      fill: "url(#SVGID_00000086678489580080972050000018311272346964833955_)"
    },
    width: 500,
    height: 500
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_00000136396409897110860840000007533484409247681667_",
    gradientUnits: "userSpaceOnUse",
    x1: 2439.8875,
    y1: -692.615,
    x2: 2516.1313,
    y2: -692.615
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#F12711"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#F5AF19"
    }
  })), /*#__PURE__*/React.createElement("rect", {
    x: 2439.89,
    y: -730.74,
    style: {
      fill: "url(#SVGID_00000136396409897110860840000007533484409247681667_)"
    },
    width: 76.24,
    height: 76.24
  })), /*#__PURE__*/React.createElement("g", {
    id: "OBJECTS"
  }, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_00000116955903471968358140000009486314187844842420_",
    gradientUnits: "userSpaceOnUse",
    x1: 77.6769,
    y1: -597.1592,
    x2: 77.6769,
    y2: -658.4444
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#001AC3"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#05EAFF"
    }
  })), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "url(#SVGID_00000116955903471968358140000009486314187844842420_)"
    },
    d: "M105.64-597.16 c-1.48,0-2.68-1.2-2.68-2.68v-27.97c0-13.94-11.35-25.29-25.29-25.29s-25.29,11.35-25.29,25.29v27.97c0,1.48-1.2,2.68-2.68,2.68 c-1.48,0-2.68-1.2-2.68-2.68v-27.97c0-16.9,13.75-30.64,30.64-30.64c16.9,0,30.64,13.75,30.64,30.64v27.97 C108.32-598.36,107.12-597.16,105.64-597.16z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_00000157288851902673996080000008085866313069626785_",
    gradientUnits: "userSpaceOnUse",
    x1: 64.7856,
    y1: -577.9304,
    x2: 90.9486,
    y2: -577.9304
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#F12711"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#F5AF19"
    }
  })), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "url(#SVGID_00000157288851902673996080000008085866313069626785_)"
    },
    d: "M79.96-576H67.05 c-1.06,0-1.93-0.86-1.93-1.93l0,0c0-1.06,0.86-1.93,1.93-1.93h12.91c1.06,0,1.93,0.86,1.93,1.93l0,0 C81.88-576.87,81.02-576,79.96-576z"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_00000150782172549574686880000017771062582255341233_",
    gradientUnits: "userSpaceOnUse",
    x1: 64.7853,
    y1: -577.9304,
    x2: 90.9486,
    y2: -577.9304
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#F12711"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#F5AF19"
    }
  })), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "url(#SVGID_00000150782172549574686880000017771062582255341233_)"
    },
    d: "M88.31-576h-2.62 c-1.06,0-1.93-0.86-1.93-1.93l0,0c0-1.06,0.86-1.93,1.93-1.93h2.62c1.06,0,1.93,0.86,1.93,1.93l0,0 C90.23-576.87,89.37-576,88.31-576z"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_00000079448947913381715440000017571777538550623932_",
    gradientUnits: "userSpaceOnUse",
    x1: 73.5683,
    y1: -476.068,
    x2: 73.5683,
    y2: -544.7638
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#F12711"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#F5AF19"
    }
  })), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "url(#SVGID_00000079448947913381715440000017571777538550623932_)"
    },
    d: "M150.79-544.76 c-21.28,22-47.45,29.34-47.71,29.43v20.48c0,5.51-4.46,9.97-9.97,9.97H62.25c-5.51,0-9.97-4.46-9.97-9.97v-9.79 c-38.99,2.86-55.93-17.83-55.93-17.83s1.45,16.4,14.78,22l-0.39,6.46c-1.17,9.53,6.26,17.94,15.86,17.94h102.15 c9.6,0,17.04-8.41,15.86-17.94l-3.19-25.91C148.99-530.33,150.79-544.76,150.79-544.76z"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_00000072985027635800248070000014176617061896354177_",
    gradientUnits: "userSpaceOnUse",
    x1: -4.2235,
    y1: -537.8481,
    x2: 136.2652,
    y2: -598.1758
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#001AC3"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#05EAFF"
    }
  })), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "url(#SVGID_00000072985027635800248070000014176617061896354177_)"
    },
    d: "M150.11-577.93 c1.09,8.8-7.26,14.51-13.18,18.16l-4.41-37.31c-0.99-8.01-7.79-14.03-15.86-14.03h-0.37c-2.74,0-4.92,2.31-4.76,5.05l0.36,6.23 c0,3.44-2.8,6.24-6.24,6.24c-3.44,0-6.24-2.8-6.24-6.24l-0.39-6.78c-0.15-2.52-2.23-4.5-4.76-4.5H60.36 c-2.74,0-4.92,2.31-4.76,5.05l0.36,6.23c0,3.71-3.26,6.68-7.07,6.19c-3.15-0.4-5.42-3.24-5.42-6.41v-6.29 c0-2.64-2.14-4.77-4.77-4.77c-8.07,0-14.88,6.02-15.86,14.03c0,0-8.53,65.95-8.6,65.95c-6.74,0.27-20.93-5.01-20.93-5.01 c11.75,13.25,28.19,20.99,58.97,18.83v-61.34c0-5.51,4.46-9.97,9.97-9.97h30.86c5.51,0,9.97,4.46,9.97,9.97c0,0,0,50.64,0,50.65 c15.91-5.36,44.06-20.96,48.21-29.67C154.45-564.3,153.2-571.53,150.11-577.93z"
  }), /*#__PURE__*/React.createElement("radialGradient", {
    id: "SVGID_00000041264115763890436960000013843193717756547485_",
    cx: 26.1543,
    cy: -562.8164,
    r: 21.5367,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#130066"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#0B003B"
    }
  })), /*#__PURE__*/React.createElement("polygon", {
    style: {
      fill: "url(#SVGID_00000041264115763890436960000013843193717756547485_)"
    },
    points: "27.07,-592.59 19.73,-533.04  32.58,-585.33  "
  }), /*#__PURE__*/React.createElement("radialGradient", {
    id: "SVGID_00000093893614599495946110000009974074347846608814_",
    cx: 123.1993,
    cy: -492.1703,
    r: 14.1749,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#130066"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#0B003B"
    }
  })), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "url(#SVGID_00000093893614599495946110000009974074347846608814_)"
    },
    d: "M138.52-503.37 c-0.03,0.28-0.05,0.55-0.09,0.83c-0.54,4.08-1.84,8.13-4.37,11.37c-4.67,5.99-12.64,8.26-20.16,9.38 c-2.43,0.36-4.87,0.62-7.32,0.81h22.18c3.17,0,6.2-1.36,8.3-3.74c2.1-2.38,3.08-5.55,2.7-8.69L138.52-503.37z"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_00000023263201409055850320000005729243451404640129_",
    gradientUnits: "userSpaceOnUse",
    x1: 147.2948,
    y1: -574.1631,
    x2: 135.0948,
    y2: -557.0831
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#75F3FF"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.0311,
    style: {
      stopColor: "#6DE3EE"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.1419,
    style: {
      stopColor: "#54AEB7"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.2566,
    style: {
      stopColor: "#3E8086"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.3725,
    style: {
      stopColor: "#2B595D"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.49,
    style: {
      stopColor: "#1B383B"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.6097,
    style: {
      stopColor: "#0F2021"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.7323,
    style: {
      stopColor: "#070E0F"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.8598,
    style: {
      stopColor: "#020304"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#000000"
    }
  })), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "url(#SVGID_00000023263201409055850320000005729243451404640129_)"
    },
    d: "M136.93-559.77l-1.24-10.51l-2.16,3.15 c0,0-13.25,22.66,4.18,13.42c17.43-9.24,12.4-24.21,12.4-24.21C151.2-569.13,142.85-563.42,136.93-559.77z"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_00000054987350314411741290000016050447545805969549_",
    gradientUnits: "userSpaceOnUse",
    x1: 103.0782,
    y1: -539.9006,
    x2: 135.2793,
    y2: -539.9006
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#75F3FF"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.005741179,
    style: {
      stopColor: "#73EFFB"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.0852,
    style: {
      stopColor: "#5BBEC7"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.1701,
    style: {
      stopColor: "#469198"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.2582,
    style: {
      stopColor: "#336A6F"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.3506,
    style: {
      stopColor: "#23494D"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.4482,
    style: {
      stopColor: "#162E31"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.553,
    style: {
      stopColor: "#0C1A1B"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.6684,
    style: {
      stopColor: "#050B0C"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.8025,
    style: {
      stopColor: "#010303"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#000000"
    }
  })), /*#__PURE__*/React.createElement("path", {
    style: {
      opacity: 0.4,
      fill: "url(#SVGID_00000054987350314411741290000016050447545805969549_)"
    },
    d: "M135.28-551.79 c-10.33,6.11-21.1,11.48-32.2,16.05c0,4.65,0,7.73,0,7.73c8.37-2.82,20.14-8.48,30.01-14.48 C134.12-545.5,134.85-548.63,135.28-551.79z"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_00000161626461562500681060000018109119903594078607_",
    gradientUnits: "userSpaceOnUse",
    x1: 107.6232,
    y1: -529.3602,
    x2: 150.787,
    y2: -529.3602
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#000000"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.2079,
    style: {
      stopColor: "#030100"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.3429,
    style: {
      stopColor: "#0B0501"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.4572,
    style: {
      stopColor: "#1A0B03"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.5599,
    style: {
      stopColor: "#2F1406"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.6549,
    style: {
      stopColor: "#4B1F0A"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.7443,
    style: {
      stopColor: "#6C2D0E"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.8292,
    style: {
      stopColor: "#943E13"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.9106,
    style: {
      stopColor: "#C25219"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.9866,
    style: {
      stopColor: "#F56720"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#FF6B21"
    }
  })), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "url(#SVGID_00000161626461562500681060000018109119903594078607_)"
    },
    d: "M107.62-516.87 c3.39,3.1,9.51,5.23,19.69-1.72c17.8-12.16,23.47-26.18,23.47-26.18C134.81-528.24,116.08-519.99,107.62-516.87z"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_00000038401300895603322090000001109827250244023722_",
    gradientUnits: "userSpaceOnUse",
    x1: 1.3048,
    y1: -508.089,
    x2: 10.521,
    y2: -512.0465
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#FF6B21"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.001678884,
    style: {
      stopColor: "#FE6B21"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.1236,
    style: {
      stopColor: "#C35219"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.2471,
    style: {
      stopColor: "#903C13"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.3719,
    style: {
      stopColor: "#642A0D"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.4968,
    style: {
      stopColor: "#401B08"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.6218,
    style: {
      stopColor: "#240F05"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.747,
    style: {
      stopColor: "#100702"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.8728,
    style: {
      stopColor: "#040201"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#000000"
    }
  })), /*#__PURE__*/React.createElement("path", {
    style: {
      opacity: 0.64,
      fill: "url(#SVGID_00000038401300895603322090000001109827250244023722_)"
    },
    d: "M11.13-500.47l-0.29,4.77 c4.91-1.85,7.67-4.41,1.78-7.66c-13.32-7.35-16.27-19.11-16.27-19.11S-2.2-506.07,11.13-500.47z"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_00000114058898932881399610000004069126542577350279_",
    gradientUnits: "userSpaceOnUse",
    x1: -6.6945,
    y1: -526.6641,
    x2: 35.8837,
    y2: -526.6641
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#75F3FF"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.001678884,
    style: {
      stopColor: "#75F2FE"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.1236,
    style: {
      stopColor: "#5ABAC3"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.2471,
    style: {
      stopColor: "#428990"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.3719,
    style: {
      stopColor: "#2E5F64"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.4968,
    style: {
      stopColor: "#1D3D40"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.6218,
    style: {
      stopColor: "#102224"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.747,
    style: {
      stopColor: "#070F10"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.8728,
    style: {
      stopColor: "#020404"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#000000"
    }
  })), /*#__PURE__*/React.createElement("path", {
    style: {
      opacity: 0.4,
      fill: "url(#SVGID_00000114058898932881399610000004069126542577350279_)"
    },
    d: "M35.29-517.19 c1.59-2.99,0.33-5.84-8.29-6.91c-21.16-2.62-33.69-12.05-33.69-12.05C2.68-525.57,15.05-518.51,35.29-517.19z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_00000085955891116544212310000003185116641893569692_",
    gradientUnits: "userSpaceOnUse",
    x1: 1980.0598,
    y1: -555.7118,
    x2: 1980.0598,
    y2: -709.3701
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#001AC3"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#05EAFF"
    }
  })), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "url(#SVGID_00000085955891116544212310000003185116641893569692_)"
    },
    d: "M2050.18-555.71 c-3.71,0-6.71-3-6.71-6.71v-70.12c0-34.96-28.45-63.41-63.41-63.41c-34.96,0-63.41,28.45-63.41,63.41v70.12 c0,3.71-3,6.71-6.71,6.71c-3.71,0-6.71-3-6.71-6.71v-70.12c0-42.36,34.47-76.83,76.83-76.83c42.36,0,76.83,34.47,76.83,76.83 v70.12C2056.89-558.72,2053.88-555.71,2050.18-555.71z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_00000103252860394096323420000006929450645347494791_",
    gradientUnits: "userSpaceOnUse",
    x1: 1947.7379,
    y1: -507.5001,
    x2: 2013.3356,
    y2: -507.5001
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#F12711"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#F5AF19"
    }
  })), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "url(#SVGID_00000103252860394096323420000006929450645347494791_)"
    },
    d: "M1985.78-502.67h-32.37 c-2.67,0-4.83-2.16-4.83-4.83l0,0c0-2.67,2.16-4.83,4.83-4.83h32.37c2.67,0,4.83,2.16,4.83,4.83l0,0 C1990.61-504.83,1988.45-502.67,1985.78-502.67z"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_00000172429499459928354410000004663434033514492065_",
    gradientUnits: "userSpaceOnUse",
    x1: 1947.7371,
    y1: -507.5001,
    x2: 2013.3353,
    y2: -507.5001
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#F12711"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#F5AF19"
    }
  })), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "url(#SVGID_00000172429499459928354410000004663434033514492065_)"
    },
    d: "M2006.71-502.67h-6.56 c-2.67,0-4.83-2.16-4.83-4.83l0,0c0-2.67,2.16-4.83,4.83-4.83h6.56c2.67,0,4.83,2.16,4.83,4.83l0,0 C2011.54-504.83,2009.38-502.67,2006.71-502.67z"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_00000032639897519024061290000006007078418481496968_",
    gradientUnits: "userSpaceOnUse",
    x1: 1969.7585,
    y1: -252.1039,
    x2: 1969.7585,
    y2: -424.3426
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#F12711"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#F5AF19"
    }
  })), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "url(#SVGID_00000032639897519024061290000006007078418481496968_)"
    },
    d: "M2163.37-424.34 c-53.35,55.17-118.97,73.56-119.62,73.79v51.35c0,13.81-11.19,25-25,25h-77.37c-13.81,0-25-11.19-25-25v-24.54 c-97.75,7.18-140.22-44.71-140.22-44.71s3.63,41.11,37.05,55.16l-0.98,16.21c-2.95,23.9,15.7,44.98,39.78,44.98h256.11 c24.08,0,42.72-21.08,39.78-44.98l-8.01-64.96C2158.86-388.15,2163.37-424.34,2163.37-424.34z"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_00000118372635077764077370000010982199360621854115_",
    gradientUnits: "userSpaceOnUse",
    x1: 1774.7135,
    y1: -407.0031,
    x2: 2126.9563,
    y2: -558.2606
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#001AC3"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#05EAFF"
    }
  })), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "url(#SVGID_00000118372635077764077370000010982199360621854115_)"
    },
    d: "M2161.68-507.5 c2.73,22.07-18.21,36.39-33.05,45.53l-11.05-93.55c-2.48-20.09-19.54-35.18-39.78-35.18h-0.92c-6.88,0-12.34,5.78-11.94,12.65 l0.9,15.62c0,8.63-7.02,15.66-15.66,15.66c-8.63,0-15.66-7.02-15.66-15.66l-0.98-17c-0.36-6.33-5.6-11.28-11.94-11.28h-84.96 c-6.88,0-12.34,5.78-11.94,12.65l0.9,15.62c0,9.31-8.17,16.75-17.72,15.52c-7.89-1.01-13.59-8.11-13.59-16.07v-15.76 c0-6.61-5.36-11.96-11.96-11.96c-20.24,0-37.3,15.09-39.78,35.18c0,0-21.4,165.35-21.55,165.35 c-16.9,0.67-52.47-12.56-52.47-12.56c29.47,33.22,70.69,52.64,147.85,47.21v-153.79c0-13.81,11.19-25,25-25h77.37 c13.81,0,25,11.19,25,25c0,0,0,126.97,0,126.98c39.88-13.44,110.47-52.56,120.88-74.39 C2172.56-473.33,2169.41-491.45,2161.68-507.5z"
  }), /*#__PURE__*/React.createElement("radialGradient", {
    id: "SVGID_00000146491331133319734260000018193261675504901268_",
    cx: 1850.879,
    cy: -469.6052,
    r: 53.9982,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#130066"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#0B003B"
    }
  })), /*#__PURE__*/React.createElement("polygon", {
    style: {
      fill: "url(#SVGID_00000146491331133319734260000018193261675504901268_)"
    },
    points: "1853.18,-544.25  1834.77,-394.96 1866.98,-526.06  "
  }), /*#__PURE__*/React.createElement("radialGradient", {
    id: "SVGID_00000025407067339056853430000011296242303632744865_",
    cx: 2094.1965,
    cy: -292.4766,
    r: 35.5403,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#130066"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#0B003B"
    }
  })), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "url(#SVGID_00000025407067339056853430000011296242303632744865_)"
    },
    d: "M2132.6-320.55 c-0.07,0.69-0.14,1.39-0.23,2.08c-1.34,10.22-4.62,20.39-10.96,28.52c-11.72,15.03-31.7,20.71-50.55,23.51 c-6.09,0.9-12.22,1.55-18.36,2.03h55.61c7.96,0,15.54-3.42,20.81-9.38c5.27-5.96,7.73-13.9,6.76-21.8L2132.6-320.55z"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_00000158732314375314387200000011253296238259794065_",
    gradientUnits: "userSpaceOnUse",
    x1: 2154.6106,
    y1: -498.0545,
    x2: 2124.0217,
    y2: -455.2304
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#75F3FF"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.0311,
    style: {
      stopColor: "#6DE3EE"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.1419,
    style: {
      stopColor: "#54AEB7"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.2566,
    style: {
      stopColor: "#3E8086"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.3725,
    style: {
      stopColor: "#2B595D"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.49,
    style: {
      stopColor: "#1B383B"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.6097,
    style: {
      stopColor: "#0F2021"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.7323,
    style: {
      stopColor: "#070E0F"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.8598,
    style: {
      stopColor: "#020304"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#000000"
    }
  })), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "url(#SVGID_00000158732314375314387200000011253296238259794065_)"
    },
    d: "M2128.63-461.97l-3.11-26.35l-5.41,7.89 c0,0-33.21,56.81,10.49,33.65c43.7-23.16,31.08-60.71,31.08-60.71C2164.41-485.43,2143.47-471.11,2128.63-461.97z"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_00000093170223275057884490000006560402404317765532_",
    gradientUnits: "userSpaceOnUse",
    x1: 2043.7477,
    y1: -412.1493,
    x2: 2124.4844,
    y2: -412.1493
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#75F3FF"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.005741179,
    style: {
      stopColor: "#73EFFB"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.0852,
    style: {
      stopColor: "#5BBEC7"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.1701,
    style: {
      stopColor: "#469198"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.2582,
    style: {
      stopColor: "#336A6F"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.3506,
    style: {
      stopColor: "#23494D"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.4482,
    style: {
      stopColor: "#162E31"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.553,
    style: {
      stopColor: "#0C1A1B"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.6684,
    style: {
      stopColor: "#050B0C"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.8025,
    style: {
      stopColor: "#010303"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#000000"
    }
  })), /*#__PURE__*/React.createElement("path", {
    style: {
      opacity: 0.4,
      fill: "url(#SVGID_00000093170223275057884490000006560402404317765532_)"
    },
    d: "M2124.48-441.97 c-25.9,15.33-52.91,28.78-80.74,40.25c0,11.65,0,19.39,0,19.39c20.99-7.08,50.49-21.27,75.24-36.31 C2121.58-426.19,2123.4-434.04,2124.48-441.97z"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_00000044869540038996307520000018039142449661779330_",
    gradientUnits: "userSpaceOnUse",
    x1: 2055.1433,
    y1: -385.7217,
    x2: 2163.3665,
    y2: -385.7217
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#000000"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.2079,
    style: {
      stopColor: "#030100"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.3429,
    style: {
      stopColor: "#0B0501"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.4572,
    style: {
      stopColor: "#1A0B03"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.5599,
    style: {
      stopColor: "#2F1406"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.6549,
    style: {
      stopColor: "#4B1F0A"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.7443,
    style: {
      stopColor: "#6C2D0E"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.8292,
    style: {
      stopColor: "#943E13"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.9106,
    style: {
      stopColor: "#C25219"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.9866,
    style: {
      stopColor: "#F56720"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#FF6B21"
    }
  })), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "url(#SVGID_00000044869540038996307520000018039142449661779330_)"
    },
    d: "M2055.14-354.4 c8.49,7.77,23.85,13.12,49.37-4.31c44.63-30.48,58.86-65.64,58.86-65.64C2123.31-382.92,2076.34-362.24,2055.14-354.4z"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_00000074417717289816435400000014517252712417779847_",
    gradientUnits: "userSpaceOnUse",
    x1: 1788.5746,
    y1: -332.389,
    x2: 1811.6819,
    y2: -342.3116
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#FF6B21"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.001678884,
    style: {
      stopColor: "#FE6B21"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.1236,
    style: {
      stopColor: "#C35219"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.2471,
    style: {
      stopColor: "#903C13"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.3719,
    style: {
      stopColor: "#642A0D"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.4968,
    style: {
      stopColor: "#401B08"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.6218,
    style: {
      stopColor: "#240F05"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.747,
    style: {
      stopColor: "#100702"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.8728,
    style: {
      stopColor: "#040201"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#000000"
    }
  })), /*#__PURE__*/React.createElement("path", {
    style: {
      opacity: 0.64,
      fill: "url(#SVGID_00000074417717289816435400000014517252712417779847_)"
    },
    d: "M1813.2-313.29l-0.72,11.96 c12.32-4.64,19.24-11.06,4.47-19.21c-33.41-18.44-40.81-47.9-40.81-47.9S1779.78-327.34,1813.2-313.29z"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_00000146486780790455527200000002678747340266201774_",
    gradientUnits: "userSpaceOnUse",
    x1: 1768.5183,
    y1: -378.9618,
    x2: 1875.2731,
    y2: -378.9618
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#75F3FF"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.001678884,
    style: {
      stopColor: "#75F2FE"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.1236,
    style: {
      stopColor: "#5ABAC3"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.2471,
    style: {
      stopColor: "#428990"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.3719,
    style: {
      stopColor: "#2E5F64"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.4968,
    style: {
      stopColor: "#1D3D40"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.6218,
    style: {
      stopColor: "#102224"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.747,
    style: {
      stopColor: "#070F10"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.8728,
    style: {
      stopColor: "#020404"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#000000"
    }
  })), /*#__PURE__*/React.createElement("path", {
    style: {
      opacity: 0.4,
      fill: "url(#SVGID_00000146486780790455527200000002678747340266201774_)"
    },
    d: "M1873.79-355.2 c3.99-7.51,0.84-14.64-20.79-17.32c-53.06-6.57-84.48-30.21-84.48-30.21C1792.03-376.22,1823.04-358.52,1873.79-355.2z"
  }))), /*#__PURE__*/React.createElement("g", {
    id: "TEXTS"
  }, _g || (_g = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "st27",
    d: "M210.41-544.76l-0.05-21.64l-10.61,17.82h-3.76l-10.56-17.36v21.17h-7.83v-36.06h6.9l13.5,22.41l13.29-22.41 h6.85l0.1,36.06H210.41z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st27",
    d: "M224.52-562.79c0-10.71,8.35-18.65,19.73-18.65c11.33,0,19.73,7.88,19.73,18.65 c0,10.77-8.4,18.65-19.73,18.65C232.87-544.15,224.52-552.08,224.52-562.79z M255.54-562.79c0-6.85-4.84-11.54-11.28-11.54 c-6.44,0-11.28,4.69-11.28,11.54c0,6.85,4.84,11.54,11.28,11.54C250.69-551.26,255.54-555.94,255.54-562.79z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st27",
    d: "M303.34-554.6c0,6.23-4.95,9.84-14.42,9.84h-18.65v-36.06h17.62c9.01,0,13.65,3.76,13.65,9.38 c0,3.61-1.86,6.39-4.79,7.93C300.77-562.23,303.34-559.14,303.34-554.6z M278.56-574.54v8.5h8.29c4.07,0,6.28-1.44,6.28-4.28 s-2.21-4.22-6.28-4.22H278.56z M294.95-555.48c0-3.04-2.32-4.48-6.65-4.48h-9.74v8.91h9.74 C292.63-551.05,294.95-552.39,294.95-555.48z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st27",
    d: "M309.68-580.82h8.35v36.06h-8.35V-580.82z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st27",
    d: "M326.58-580.82h8.35v29.26h18.08v6.8h-26.43V-580.82z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st27",
    d: "M385.62-551.46v6.7h-27.92v-36.06h27.25v6.7h-18.96v7.83h16.74v6.49h-16.74v8.35H385.62z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st27",
    d: "M404.01-548.32l2.83-6.28c3.04,2.21,7.57,3.76,11.9,3.76c4.95,0,6.96-1.65,6.96-3.86 c0-6.75-20.97-2.11-20.97-15.51c0-6.13,4.95-11.23,15.2-11.23c4.53,0,9.17,1.08,12.52,3.19l-2.58,6.34 c-3.35-1.91-6.8-2.83-9.99-2.83c-4.95,0-6.85,1.86-6.85,4.12c0,6.65,20.97,2.06,20.97,15.3c0,6.03-5,11.18-15.3,11.18 C412.97-544.15,407.2-545.85,404.01-548.32z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st27",
    d: "M472.78-580.82v36.06h-8.35v-14.78h-16.38v14.78h-8.35v-36.06h8.35v14.22h16.38v-14.22H472.78z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st27",
    d: "M479.07-562.79c0-10.71,8.35-18.65,19.73-18.65c11.33,0,19.73,7.88,19.73,18.65 c0,10.77-8.4,18.65-19.73,18.65C487.42-544.15,479.07-552.08,479.07-562.79z M510.08-562.79c0-6.85-4.84-11.54-11.28-11.54 c-6.44,0-11.28,4.69-11.28,11.54c0,6.85,4.84,11.54,11.28,11.54C505.24-551.26,510.08-555.94,510.08-562.79z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st27",
    d: "M556.09-567.74c0,8.04-6.03,13.03-15.66,13.03h-7.26v9.94h-8.35v-36.06h15.61 C550.06-580.82,556.09-575.83,556.09-567.74z M547.64-567.74c0-3.97-2.58-6.28-7.68-6.28h-6.8v12.52h6.8 C545.06-561.51,547.64-563.82,547.64-567.74z"
  }))), /*#__PURE__*/React.createElement("text", {
    transform: "matrix(1 0 0 1 173.3156 -209.8096)",
    style: {
      fill: "#FFFFFF",
      fontFamily: "'Montserrat-Bold'",
      fontSize: "51.5178px"
    }
  }, "Mobile SHOP"), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_00000140015097549236151160000005046684658367814847_",
    gradientUnits: "userSpaceOnUse",
    x1: -373.5089,
    y1: -512.963,
    x2: -296.9046,
    y2: -512.963,
    gradientTransform: "matrix(-1 0 0 1 -119.3135 0)"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#001AC3"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#05EAFF"
    }
  })), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "url(#SVGID_00000140015097549236151160000005046684658367814847_)"
    },
    d: "M252.6-511.37h-73.41 c-0.88,0-1.6-0.71-1.6-1.6l0,0c0-0.88,0.71-1.6,1.6-1.6h73.41c0.88,0,1.6,0.71,1.6,1.6l0,0 C254.2-512.08,253.48-511.37,252.6-511.37z"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_00000051372576196942803020000003947209212410246283_",
    gradientUnits: "userSpaceOnUse",
    x1: 479.4838,
    y1: -512.963,
    x2: 556.0883,
    y2: -512.963
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#001AC3"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#05EAFF"
    }
  })), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "url(#SVGID_00000051372576196942803020000003947209212410246283_)"
    },
    d: "M481.08-511.37h73.41 c0.88,0,1.6-0.71,1.6-1.6l0,0c0-0.88-0.71-1.6-1.6-1.6h-73.41c-0.88,0-1.6,0.71-1.6,1.6l0,0 C479.48-512.08,480.2-511.37,481.08-511.37z"
  })), /*#__PURE__*/React.createElement("text", {
    transform: "matrix(1 0 0 1 301.5105 -506.2734)",
    className: "st44 st45",
    style: {
      fill: "#FFFFFF"
    }
  }, "Buy &amp; sell")), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_00000134243811754124936490000011292998872008909246_",
    gradientUnits: "userSpaceOnUse",
    x1: 88.8339,
    y1: 62.7314,
    x2: 88.8339,
    y2: 1.4462
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#001AC3"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#05EAFF"
    }
  })), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "url(#SVGID_00000134243811754124936490000011292998872008909246_)"
    },
    d: "M116.8,62.73 c-1.48,0-2.68-1.2-2.68-2.68V32.09c0-13.94-11.35-25.29-25.29-25.29S63.54,18.14,63.54,32.09v27.97c0,1.48-1.2,2.68-2.68,2.68 c-1.48,0-2.68-1.2-2.68-2.68V32.09c0-16.9,13.75-30.64,30.64-30.64c16.9,0,30.64,13.75,30.64,30.64v27.97 C119.48,61.53,118.28,62.73,116.8,62.73z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_00000026862511185145131420000002176234504191847346_",
    gradientUnits: "userSpaceOnUse",
    x1: 75.9427,
    y1: 81.9602,
    x2: 102.1057,
    y2: 81.9602
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#F12711"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#F5AF19"
    }
  })), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "url(#SVGID_00000026862511185145131420000002176234504191847346_)"
    },
    d: "M91.11,83.89H78.21 c-1.06,0-1.93-0.86-1.93-1.93l0,0c0-1.06,0.86-1.93,1.93-1.93h12.91c1.06,0,1.93,0.86,1.93,1.93l0,0 C93.04,83.02,92.18,83.89,91.11,83.89z"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_00000063592865891567494760000008820460218207356558_",
    gradientUnits: "userSpaceOnUse",
    x1: 75.9423,
    y1: 81.9602,
    x2: 102.1056,
    y2: 81.9602
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#F12711"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#F5AF19"
    }
  })), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "url(#SVGID_00000063592865891567494760000008820460218207356558_)"
    },
    d: "M99.46,83.89h-2.62 c-1.06,0-1.93-0.86-1.93-1.93l0,0c0-1.06,0.86-1.93,1.93-1.93h2.62c1.06,0,1.93,0.86,1.93,1.93l0,0 C101.39,83.02,100.53,83.89,99.46,83.89z"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_00000145020998088255745710000016378844876478668191_",
    gradientUnits: "userSpaceOnUse",
    x1: 84.7254,
    y1: 183.8226,
    x2: 84.7254,
    y2: 115.1268
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#F12711"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#F5AF19"
    }
  })), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "url(#SVGID_00000145020998088255745710000016378844876478668191_)"
    },
    d: "M161.94,115.13 c-21.28,22-47.45,29.34-47.71,29.43v20.48c0,5.51-4.47,9.97-9.97,9.97H73.41c-5.51,0-9.97-4.46-9.97-9.97v-9.79 c-38.99,2.86-55.93-17.83-55.93-17.83s1.45,16.4,14.78,22l-0.39,6.46c-1.17,9.53,6.26,17.94,15.86,17.94h102.15 c9.6,0,17.04-8.41,15.86-17.94l-3.19-25.91C160.15,129.56,161.94,115.13,161.94,115.13z"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_00000089546432406700223930000002813962672503923353_",
    gradientUnits: "userSpaceOnUse",
    x1: 6.9335,
    y1: 122.0425,
    x2: 147.4223,
    y2: 61.7148
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#001AC3"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#05EAFF"
    }
  })), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "url(#SVGID_00000089546432406700223930000002813962672503923353_)"
    },
    d: "M161.27,81.96 c1.09,8.8-7.26,14.51-13.18,18.16l-4.41-37.31c-0.99-8.01-7.79-14.03-15.86-14.03h-0.37c-2.74,0-4.92,2.31-4.76,5.05l0.36,6.23 c0,3.44-2.8,6.24-6.24,6.24c-3.44,0-6.24-2.8-6.24-6.24l-0.39-6.78c-0.15-2.52-2.23-4.5-4.76-4.5H71.52 c-2.74,0-4.92,2.31-4.76,5.05l0.36,6.23c0,3.71-3.26,6.68-7.07,6.19c-3.15-0.4-5.42-3.24-5.42-6.41v-6.29 c0-2.64-2.14-4.77-4.77-4.77c-8.07,0-14.88,6.02-15.86,14.03c0,0-8.53,65.95-8.6,65.95c-6.74,0.27-20.93-5.01-20.93-5.01 c11.75,13.25,28.19,20.99,58.97,18.83V81.24c0-5.51,4.46-9.97,9.97-9.97h30.86c5.51,0,9.97,4.46,9.97,9.97c0,0,0,50.64,0,50.65 c15.91-5.36,44.06-20.96,48.21-29.67C165.61,95.59,164.35,88.36,161.27,81.96z"
  }), /*#__PURE__*/React.createElement("radialGradient", {
    id: "SVGID_00000082340591672647966670000014677700309240615609_",
    cx: 37.3114,
    cy: 97.0742,
    r: 21.5367,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#130066"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#0B003B"
    }
  })), /*#__PURE__*/React.createElement("polygon", {
    style: {
      fill: "url(#SVGID_00000082340591672647966670000014677700309240615609_)"
    },
    points: "38.23,67.3 30.89,126.85  43.73,74.56  "
  }), /*#__PURE__*/React.createElement("radialGradient", {
    id: "SVGID_00000176734714504877903600000015206700143647991462_",
    cx: 134.3564,
    cy: 167.7203,
    r: 14.1749,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#130066"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#0B003B"
    }
  })), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "url(#SVGID_00000176734714504877903600000015206700143647991462_)"
    },
    d: "M149.67,156.52 c-0.03,0.28-0.05,0.55-0.09,0.83c-0.54,4.08-1.84,8.13-4.37,11.37c-4.67,5.99-12.64,8.26-20.16,9.38 c-2.43,0.36-4.87,0.62-7.32,0.81h22.18c3.17,0,6.2-1.36,8.3-3.74c2.1-2.38,3.08-5.55,2.7-8.69L149.67,156.52z"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_00000127723136397861913900000015649198685753094021_",
    gradientUnits: "userSpaceOnUse",
    x1: 158.4519,
    y1: 85.7274,
    x2: 146.2519,
    y2: 102.8074
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#75F3FF"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.0311,
    style: {
      stopColor: "#6DE3EE"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.1419,
    style: {
      stopColor: "#54AEB7"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.2566,
    style: {
      stopColor: "#3E8086"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.3725,
    style: {
      stopColor: "#2B595D"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.49,
    style: {
      stopColor: "#1B383B"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.6097,
    style: {
      stopColor: "#0F2021"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.7323,
    style: {
      stopColor: "#070E0F"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.8598,
    style: {
      stopColor: "#020304"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#000000"
    }
  })), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "url(#SVGID_00000127723136397861913900000015649198685753094021_)"
    },
    d: "M148.09,100.12l-1.24-10.51l-2.16,3.15 c0,0-13.25,22.66,4.18,13.42c17.43-9.24,12.4-24.21,12.4-24.21C162.36,90.76,154.01,96.47,148.09,100.12z"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_00000130612019460277363740000001593663126758390716_",
    gradientUnits: "userSpaceOnUse",
    x1: 114.2353,
    y1: 119.9899,
    x2: 146.4364,
    y2: 119.9899
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#75F3FF"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.005741179,
    style: {
      stopColor: "#73EFFB"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.0852,
    style: {
      stopColor: "#5BBEC7"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.1701,
    style: {
      stopColor: "#469198"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.2582,
    style: {
      stopColor: "#336A6F"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.3506,
    style: {
      stopColor: "#23494D"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.4482,
    style: {
      stopColor: "#162E31"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.553,
    style: {
      stopColor: "#0C1A1B"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.6684,
    style: {
      stopColor: "#050B0C"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.8025,
    style: {
      stopColor: "#010303"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#000000"
    }
  })), /*#__PURE__*/React.createElement("path", {
    style: {
      opacity: 0.4,
      fill: "url(#SVGID_00000130612019460277363740000001593663126758390716_)"
    },
    d: "M146.44,108.1 c-10.33,6.11-21.1,11.48-32.2,16.05c0,4.65,0,7.73,0,7.73c8.37-2.82,20.14-8.48,30.01-14.48 C145.28,114.39,146.01,111.26,146.44,108.1z"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_00000181772937781949270770000018217683596035266236_",
    gradientUnits: "userSpaceOnUse",
    x1: 118.7803,
    y1: 130.5303,
    x2: 161.9441,
    y2: 130.5303
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#000000"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.2079,
    style: {
      stopColor: "#030100"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.3429,
    style: {
      stopColor: "#0B0501"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.4572,
    style: {
      stopColor: "#1A0B03"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.5599,
    style: {
      stopColor: "#2F1406"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.6549,
    style: {
      stopColor: "#4B1F0A"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.7443,
    style: {
      stopColor: "#6C2D0E"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.8292,
    style: {
      stopColor: "#943E13"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.9106,
    style: {
      stopColor: "#C25219"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.9866,
    style: {
      stopColor: "#F56720"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#FF6B21"
    }
  })), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "url(#SVGID_00000181772937781949270770000018217683596035266236_)"
    },
    d: "M118.78,143.02 c3.39,3.1,9.51,5.23,19.69-1.72c17.8-12.16,23.47-26.18,23.47-26.18C145.97,131.65,127.23,139.9,118.78,143.02z"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_00000160907558473256932640000007544570459268042416_",
    gradientUnits: "userSpaceOnUse",
    x1: 12.4619,
    y1: 151.8016,
    x2: 21.678,
    y2: 147.844
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#FF6B21"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.001678884,
    style: {
      stopColor: "#FE6B21"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.1236,
    style: {
      stopColor: "#C35219"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.2471,
    style: {
      stopColor: "#903C13"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.3719,
    style: {
      stopColor: "#642A0D"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.4968,
    style: {
      stopColor: "#401B08"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.6218,
    style: {
      stopColor: "#240F05"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.747,
    style: {
      stopColor: "#100702"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.8728,
    style: {
      stopColor: "#040201"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#000000"
    }
  })), /*#__PURE__*/React.createElement("path", {
    style: {
      opacity: 0.64,
      fill: "url(#SVGID_00000160907558473256932640000007544570459268042416_)"
    },
    d: "M22.29,159.42L22,164.19 c4.91-1.85,7.67-4.41,1.78-7.66c-13.32-7.35-16.27-19.11-16.27-19.11S8.96,153.82,22.29,159.42z"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_00000134252051990347889700000007172869836210094524_",
    gradientUnits: "userSpaceOnUse",
    x1: 4.4626,
    y1: 133.2265,
    x2: 47.0408,
    y2: 133.2265
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#75F3FF"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.001678884,
    style: {
      stopColor: "#75F2FE"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.1236,
    style: {
      stopColor: "#5ABAC3"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.2471,
    style: {
      stopColor: "#428990"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.3719,
    style: {
      stopColor: "#2E5F64"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.4968,
    style: {
      stopColor: "#1D3D40"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.6218,
    style: {
      stopColor: "#102224"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.747,
    style: {
      stopColor: "#070F10"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.8728,
    style: {
      stopColor: "#020404"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#000000"
    }
  })), /*#__PURE__*/React.createElement("path", {
    style: {
      opacity: 0.4,
      fill: "url(#SVGID_00000134252051990347889700000007172869836210094524_)"
    },
    d: "M46.45,142.7 c1.59-2.99,0.33-5.84-8.29-6.91c-21.16-2.62-33.69-12.05-33.69-12.05C13.84,134.32,26.21,141.38,46.45,142.7z"
  })), _g2 || (_g2 = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "st27",
    d: "M221.56,115.13l-0.05-21.64l-10.61,17.82h-3.76l-10.56-17.36v21.17h-7.83V79.07h6.9l13.5,22.41l13.29-22.41 h6.85l0.1,36.06H221.56z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st27",
    d: "M235.68,97.1c0-10.71,8.35-18.65,19.73-18.65c11.33,0,19.73,7.88,19.73,18.65 c0,10.77-8.4,18.65-19.73,18.65C244.03,115.74,235.68,107.81,235.68,97.1z M266.69,97.1c0-6.85-4.84-11.54-11.28-11.54 c-6.44,0-11.28,4.69-11.28,11.54c0,6.85,4.84,11.54,11.28,11.54C261.85,108.64,266.69,103.95,266.69,97.1z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st27",
    d: "M314.5,105.29c0,6.23-4.95,9.84-14.42,9.84h-18.65V79.07h17.62c9.01,0,13.65,3.76,13.65,9.38 c0,3.61-1.86,6.39-4.79,7.93C311.92,97.66,314.5,100.75,314.5,105.29z M289.72,85.35v8.5h8.29c4.07,0,6.28-1.44,6.28-4.28 s-2.21-4.22-6.28-4.22H289.72z M306.1,104.41c0-3.04-2.32-4.48-6.65-4.48h-9.74v8.91h9.74 C303.79,108.84,306.1,107.5,306.1,104.41z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st27",
    d: "M320.84,79.07h8.35v36.06h-8.35V79.07z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st27",
    d: "M337.74,79.07h8.35v29.26h18.08v6.8h-26.43V79.07z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st27",
    d: "M396.77,108.43v6.7h-27.92V79.07h27.25v6.7h-18.96v7.83h16.74v6.49h-16.74v8.35H396.77z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st27",
    d: "M415.17,111.57l2.83-6.28c3.04,2.21,7.57,3.76,11.9,3.76c4.95,0,6.96-1.65,6.96-3.86 c0-6.75-20.97-2.11-20.97-15.51c0-6.13,4.95-11.23,15.2-11.23c4.53,0,9.17,1.08,12.52,3.19l-2.58,6.34 c-3.35-1.91-6.8-2.83-9.99-2.83c-4.95,0-6.85,1.86-6.85,4.12c0,6.65,20.97,2.06,20.97,15.3c0,6.03-5,11.18-15.3,11.18 C424.13,115.74,418.36,114.04,415.17,111.57z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st27",
    d: "M483.94,79.07v36.06h-8.35v-14.78h-16.38v14.78h-8.35V79.07h8.35v14.22h16.38V79.07H483.94z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st27",
    d: "M490.23,97.1c0-10.71,8.35-18.65,19.73-18.65c11.33,0,19.73,7.88,19.73,18.65 c0,10.77-8.4,18.65-19.73,18.65C498.57,115.74,490.23,107.81,490.23,97.1z M521.24,97.1c0-6.85-4.84-11.54-11.28-11.54 c-6.44,0-11.28,4.69-11.28,11.54c0,6.85,4.84,11.54,11.28,11.54C516.4,108.64,521.24,103.95,521.24,97.1z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st27",
    d: "M567.24,92.15c0,8.04-6.03,13.03-15.66,13.03h-7.26v9.94h-8.35V79.07h15.61 C561.22,79.07,567.24,84.06,567.24,92.15z M558.8,92.15c0-3.97-2.58-6.28-7.68-6.28h-6.8v12.52h6.8 C556.22,98.38,558.8,96.07,558.8,92.15z"
  }))), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_00000005247785614667168540000013268906936339937436_",
    gradientUnits: "userSpaceOnUse",
    x1: -384.666,
    y1: 146.9276,
    x2: -308.0617,
    y2: 146.9276,
    gradientTransform: "matrix(-1 0 0 1 -119.3135 0)"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#001AC3"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#05EAFF"
    }
  })), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "url(#SVGID_00000005247785614667168540000013268906936339937436_)"
    },
    d: "M263.76,148.52h-73.41 c-0.88,0-1.6-0.71-1.6-1.6l0,0c0-0.88,0.71-1.6,1.6-1.6h73.41c0.88,0,1.6,0.71,1.6,1.6l0,0 C265.35,147.81,264.64,148.52,263.76,148.52z"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_00000013176663500620940510000005150158076729657735_",
    gradientUnits: "userSpaceOnUse",
    x1: 490.6409,
    y1: 146.9276,
    x2: 567.2453,
    y2: 146.9276
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#001AC3"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#05EAFF"
    }
  })), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "url(#SVGID_00000013176663500620940510000005150158076729657735_)"
    },
    d: "M492.24,148.52h73.41 c0.88,0,1.6-0.71,1.6-1.6l0,0c0-0.88-0.71-1.6-1.6-1.6h-73.41c-0.88,0-1.6,0.71-1.6,1.6l0,0 C490.64,147.81,491.36,148.52,492.24,148.52z"
  })), _text || (_text = /*#__PURE__*/React.createElement("text", {
    transform: "matrix(1 0 0 1 312.6675 153.6171)",
    className: "st44 st45"
  }, "Buy &amp; sell"))))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgLogo);
export default __webpack_public_path__ + "static/media/logo.c1ea9e5004140aa36c653b6ac45e17f5.svg";
export { ForwardRef as ReactComponent };